import React from 'react';

const Modal = ({ isOpen, setIsOpen, modalText }) => {

  // document.documentElement.style.overflow = isOpen ? 'hidden' : ''

  return (
    <>
      <div className={`modal-container ${isOpen ? 'active' : ''}`}>
        <div className="modal-bg" />
        <div className="modal-content">
          <span className="modal-close-btn" onClick={setIsOpen} />
          {/* eslint-disable react/no-danger */}
          <div className="modal-content-wrapper stack" dangerouslySetInnerHTML={{ __html: modalText }} />
          {/* eslint-enable react/no-danger */}
        </div>
        <div className="modal-shape" />
      </div>
    </>
  );
};

export default Modal;
